import { Component, Input, OnInit, output } from '@angular/core';
import { AvailabilityRoom1RateComponent } from "../availability-room-1-rate/availability-room-1-rate.component";

import { ImageGallery1Component } from "../image-gallery1/image-gallery1.component";
import { IAvailabilityData, SettingsService } from 'core-lib';
//animation test
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';
import { AvailabilityService } from 'core-lib';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from 'core-lib';
import { TruncatedTextComponent } from "../truncated-text/truncated-text.component";
import { extractLinkOnly } from '../../utils/extract-link-only';





@Component({
    selector: 'app-availability-room-1',
    imports: [AvailabilityRoom1RateComponent, ImageGallery1Component, ButtonModule, TranslateModule, TruncatedTextComponent],
    templateUrl: './availability-room-1.component.html',
    styleUrl: './availability-room-1.component.scss',
    animations: [
        fadeInOnEnterAnimation({ duration: 1000, delay: 100, }),
        fadeOutOnLeaveAnimation()
    ]
})
export class AvailabilityRoom1Component implements OnInit{

  @Input() roomData:any;
  @Input() isMultiRoom:boolean
  roomSelected = output<IAvailabilityData>();
  moreRatesButtonClicked = output();
  readmoreButtonClicked = output();
  fewLeft:boolean = false;
  /** Custom read more button text when the long description is a link with its own text. */
  readMoreLabel: string | null = null;
  language: string;
  @Input() roomIndex: number;
/*   hotelCode:  */

  constructor(public settings:SettingsService,  public avService: AvailabilityService, public languageService: LanguageService) {

  }

  ngOnInit(): void {
    this.readMoreLabel = extractLinkOnly(this.roomData.roomrates[0].room.pim?.longDescription)?.label ?? null;
    this.language = this.languageService.getCurrentLanguage();
    if (this.roomData.roomrates[0].room.numberOfRoomsAvailable <= this.settings.get("availability.fewLeftLimit")) {
      this.fewLeft = true;
    }
  }

  ngOnChanges() {
    this.readMoreLabel = extractLinkOnly(this.roomData.roomrates[0].room.pim?.longDescription)?.label ?? null;
    if (this.roomData.roomrates[0].room.numberOfRoomsAvailable <= this.settings.get("availability.fewLeftLimit")) {
      this.fewLeft = true;
    } else {
      this.fewLeft = false;
    }   
  }

  selectRoomRate(roomrate:any) {
    this.roomSelected.emit(roomrate);

  }



  openMoreRates() {
    this.moreRatesButtonClicked.emit(this.roomData);
  }

  readMore() {
    this.readmoreButtonClicked.emit(this.roomData);
  }
}
